/*
 * @Description: checkBox 组件
 * @Author: kadenwang@tencent.com
 * @Date: 2021-11-18 11:32:04
 * @LastEditors: yanxia@tencent.com
 * @LastEditTime: 2022-04-08 17:30:48
 */

import classnames from 'classnames';
import React from 'react';
import './CheckBox.less';


export interface ICheckBox {
  name: string;
  label: string | React.ReactNode;
  children?: React.ReactNode;
  register: any;
  error?: boolean;
}

export const CheckBox = (props: ICheckBox): React.ReactElement => {
  const { name, label, register, children, error } = props;

  return (
    <div className={classnames('form-CheckBox', { error })}>
      <input type="checkbox" ref={register} name={name} />
      <label htmlFor={name}>
        <i className="icon__checkbox" />
        {label}
      </label>
      {children}
    </div>
  );
};

CheckBox.defaultProps = {
  children: [],
};
